import _ from 'lodash';

const contactDefault = [
  {
    label: 'Phone',
    field: 'contactInformation.contactInfoPhoneNumber',
  },
  {
    label: 'Email',
    field: 'contactInformation.contactInfoEmail',
  },
  {
    label: 'Fax',
    field: 'primaryAddress.primaryAddressFaxNumber',
  },
];

export const mapToProductContact = (data) => {
  if (!data) return [];
  return contactDefault.map((lableItem) => ({
    label: lableItem?.label,
    info: _.get(data, lableItem.field),
  }));
};
